import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  EVENT_OUTCOMES,
  EVENT_OUTCOME_LABELS,
  type EventOutcome,
} from "@/hooks/useEvents";

interface EventOutcomeSelectorProps {
  currentOutcome: EventOutcome;
  onChange: (outcome: EventOutcome) => void | Promise<void>;
  disabled?: boolean;
  size?: "sm" | "default";
}

export function EventOutcomeSelector({
  currentOutcome,
  onChange,
  disabled,
  size = "default",
}: EventOutcomeSelectorProps) {
  const handleValueChange = (v: string) => {
    const next = v as EventOutcome;
    if (next === currentOutcome) return;
    onChange(next);
  };

  return (
    <Select
      value={currentOutcome}
      onValueChange={handleValueChange}
      disabled={disabled}
    >
      <SelectTrigger className={size === "sm" ? "w-28 h-8 text-xs" : "w-32"}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {EVENT_OUTCOMES.map((o) => (
          <SelectItem key={o} value={o}>
            {EVENT_OUTCOME_LABELS[o]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
